import z from "zod";
import { evalActionsSchema, evalLogicNodeSchema, EvalLimitItemEdgeEnum, EvalLimitItemOperatorEnum, EvalLimitItemParameterEnum, EvalLimitItemQuantifierTypeEnum, EvalLimitItemQuantifierUnitEnum, EvalTestCaseTypeEnum, } from "../eval/eval.schema";
import { labelSchema } from "../label/label.schema";
import { ModelOutputTypeEnum } from "../model/model.schema";
import { DashboardConfigurationZoneDirectionEnum } from "./dashboard.schema";
export const deployEvalLimitItemSchema = z.object({
    id: z.string(),
    limitFrom: z.number().nullable(),
    limitTo: z.number().nullable(),
    parameter: z.enum(EvalLimitItemParameterEnum),
    operator: z.enum(EvalLimitItemOperatorEnum),
    quantifierType: z.enum(EvalLimitItemQuantifierTypeEnum),
    quantifierUnit: z.enum(EvalLimitItemQuantifierUnitEnum),
    quantifierValue: z.number(),
    targetEdge: z.enum(EvalLimitItemEdgeEnum),
    parentEdge: z.enum(EvalLimitItemEdgeEnum),
});
export const deployEvalLimitSchema = z.object({
    id: z.string(),
    name: z.string(),
    actions: evalActionsSchema,
    enabled: z.boolean(),
    targetLabel: labelSchema,
    targetParentLabel: labelSchema.nullable(),
    limitItems: z.array(deployEvalLimitItemSchema),
});
export const deployEvalThresholdSchema = z.object({
    id: z.string(),
    name: z.string(),
    value: z.number(),
    color: z.string(),
    testCaseId: z.string().nullable(),
});
export const deployEvalTestCaseSchema = z.object({
    id: z.string(),
    name: z.string(),
    type: z.enum(EvalTestCaseTypeEnum),
    actions: evalActionsSchema,
    enabled: z.boolean(),
    limits: z.array(deployEvalLimitSchema),
    logicNodes: z.array(evalLogicNodeSchema),
    thresholds: z.array(deployEvalThresholdSchema),
});
export const deployDashboardConfigSchema = z.object({
    id: z.number(),
    name: z.string(),
    projectId: z.number(),
    projectName: z.string(),
    zoneDirection: z.enum(DashboardConfigurationZoneDirectionEnum),
    zoneCenter: z.number(),
    zoneThickness: z.number(),
    optimistic: z.boolean(),
    testCases: z.array(deployEvalTestCaseSchema),
    thresholds: z.array(deployEvalThresholdSchema),
    labels: z.array(labelSchema),
});
export const deployNnConfigSchema = z.object({
    type: z.literal("Generic"),
    model_id: z.number().nullable(),
    model_name: z.string().nullable(),
    num_inference_threads: z.number(),
    throttle_hz: z.number().nullable(),
    nn_config: z.record(z.string(), z.unknown()),
});
export const deployModelRefSchema = z.object({
    output_id: z.number(),
    type: z.enum(ModelOutputTypeEnum),
    filename: z.string(),
    size_bytes: z.number().nullable(),
});
export const dashboardDeployPayloadSchema = z.object({
    dashboard_config: deployDashboardConfigSchema,
    nn_config: deployNnConfigSchema,
    model: deployModelRefSchema,
});
export const PLATFORM_TO_OUTPUT_TYPE = {
    X_LINK_MYRIAD_X: ModelOutputTypeEnum.RVC2,
    X_LINK_MYRIAD_2: ModelOutputTypeEnum.RVC2,
    X_LINK_RVC3: ModelOutputTypeEnum.RVC3,
    X_LINK_RVC4: ModelOutputTypeEnum.RVC4,
};
export const selectDeployableOutput = (outputs, platform) => {
    const required = platform ? PLATFORM_TO_OUTPUT_TYPE[platform] : undefined;
    if (!required) {
        return null;
    }
    const candidates = outputs.filter((output) => output.type === required);
    return candidates.find((output) => output.active) ?? candidates[0] ?? null;
};
//# sourceMappingURL=deploy-payload.schema.js.map